module.exports = __webpack_public_path__ + "static/media/swish-demo-500.75c757ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swish-demo-500.png
// module id = 426
// module chunks = 0